import {CENTRAL_QUARTER_PREFIX} from "../../constants/tokens";

export const checkIfCentralQuarter = (tokenId) => {
  if(!tokenId) {
    return false;
  }
  return tokenId.includes(CENTRAL_QUARTER_PREFIX)
}